import React, { memo, useContext, useEffect, useState } from 'react';
import singleAxel from '../VehicleDiagrams/images1.png';
import doubleAxelOne from '../VehicleDiagrams/axImage01.png';
import doubleAxelTwo from '../VehicleDiagrams/azImage02.png';
import doubleAxelThree from '../VehicleDiagrams/axImage03.png';
import Grid from '@material-ui/core/Grid';
import { InputLabel, Typography, Paper } from '@material-ui/core';
import { EditInapectionContaxt } from './editInspectionProviderImports';

const style = {
    typography: {
        padding: '1.5px 14px'
        // fontWeight: 600
        // width: '560px'
    },
    brakeTypography: {
        textAlign: 'center',
        padding: 0
    },
    Ax2osOut: {
        marginTop: '-5px'
    },
    Ax2osin: {
        marginTop: 8
    },
    Ax2nsin: {
        marginTop: 134
    },
    axBreak: {
        display: 'block',
        textAlign: 'center',
        whiteSpace: 'nowrap',
        width: '100%',
        paddingLeft: '0px'
    },
    axOsout: { marginTop: 50 },
    axNsout: { marginTop: 161 },
    axImage: { marginTop: 5, marginBottom: 5 }
};

const setValue = (val, unit) => {
    if (val) {
        return (
            <>
                {val}
                <small>{unit}</small>
            </>
        );
    } else {
        return 'N/A';
    }
};

const EditAxel = memo((props) => {
    const { classes } = props;
    const { state } = useContext(EditInapectionContaxt);
    const noOfAxles = Number(props.vehicleNoOfAxles ?? state?.vehicleNoOfAxles);
    const isFourAxles = !noOfAxles || noOfAxles === 4;

    const [show, setShow] = useState({
        showAxle1: false,
        showAxle2: false,
        showAxle3: false,
        showAxle4: false
    });

    let handleAxle = () => {
        let showAxle1 = false;
        let showAxle2 = false;
        let showAxle3 = false;
        let showAxle4 = false;
        if (noOfAxles) {
            switch (noOfAxles) {
                case 1:
                    showAxle1 = true;
                    break;
                case 2:
                    showAxle1 = true;
                    showAxle2 = true;
                    break;
                case 3:
                    showAxle1 = true;
                    showAxle2 = true;
                    showAxle3 = true;
                    break;
                case 4:
                    showAxle1 = true;
                    showAxle2 = true;
                    showAxle3 = true;
                    showAxle4 = true;
                    break;

                default:
                    break;
            }
        } else {
            showAxle1 = true;
            showAxle2 = true;
            showAxle3 = true;
            showAxle4 = true;
        }

        setShow((st) => ({
            ...st,
            showAxle1: showAxle1,
            showAxle2: showAxle2,
            showAxle3: showAxle3,
            showAxle4: showAxle4
        }));
    };

    useEffect(() => {
        handleAxle();
    }, [state.vehicleNoOfAxles, props.vehicleNoOfAxles]);

    return (
        <Grid container item xs={12}>
            <Paper className={classes.paper}>
                <Grid container>
                    <h2 className={classes.headings}>Tyres Checks</h2>
                </Grid>
                <Grid container spacing={4} xs={12} style={{ marginBottom: 5 }} justify="center">
                    {/* Axel 1...................... */}
                    {show.showAxle1 && (
                        <Grid item xs={12} sm={12} md={6} lg={6} xl={3}>
                            <Grid item xs={12} sm={12}>
                                <Grid container xs={12} direction="row" justify="space-evenly">
                                    <Grid item xs={2} />
                                    <Grid item xs={3}>
                                        <h3 className={classes.axelTitles}>AXLE 1</h3>
                                    </Grid>
                                    <Grid item xs={5} />
                                </Grid>
                            </Grid>
                            <Grid item xs={12} sm={12}>
                                <Grid container xs={12} direction="row" justify="space-evenly">
                                    <Grid item xs={2}>
                                        <Grid container spacing={2}>
                                            <Grid item xs={12}>
                                                <InputLabel style={style.axOsout}>Depth</InputLabel>
                                                <Typography style={style.typography} variant="subtitle1">
                                                    {setValue(state.tyreAxles[0]?.osTreadDepth, 'mm')}
                                                </Typography>
                                            </Grid>
                                        </Grid>
                                        <Grid container spacing={2}>
                                            <Grid item xs={12}>
                                                <InputLabel style={style.axNsout}>Depth</InputLabel>
                                                <Typography style={style.typography} variant="subtitle1">
                                                    {setValue(state.tyreAxles[0]?.nsTreadDepth, 'mm')}
                                                </Typography>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                    <Grid item xs={3}>
                                        <InputLabel style={style.axBreak}>Brake Lining (%)</InputLabel>
                                        <Typography style={style.brakeTypography} variant="subtitle1">
                                            {setValue(state.tyreAxles[0]?.osBrakeLineRemaining, '%')}
                                        </Typography>
                                        <img src={singleAxel} height="250px" width="100%" style={style.axImage} />
                                        <InputLabel style={style.axBreak}>Brake Lining (%)</InputLabel>
                                        <Typography style={style.brakeTypography} variant="subtitle1">
                                            {setValue(state.tyreAxles[0]?.nsBrakeLineRemaining, '%')}
                                        </Typography>
                                    </Grid>
                                    <Grid item xs={5}>
                                        <Grid container spacing={2}>
                                            <Grid item xs={6}>
                                                {' '}
                                                <InputLabel style={style.axOsout}>Pressure</InputLabel>
                                                <Typography style={style.typography} variant="subtitle1">
                                                    {setValue(state.tyreAxles[0]?.osTyrePressure, 'psi')}
                                                </Typography>
                                            </Grid>
                                            <Grid item xs={6}>
                                                <InputLabel style={style.axOsout}>Tyre</InputLabel>
                                                <Typography style={style.typography} variant="subtitle1">
                                                    {setValue(state.tyreAxles[0]?.osTyreMaker, '')}
                                                </Typography>
                                            </Grid>
                                        </Grid>
                                        <Grid container spacing={2}>
                                            <Grid item xs={6}>
                                                {' '}
                                                <InputLabel style={style.axNsout}>Pressure</InputLabel>
                                                <Typography style={style.typography} variant="subtitle1">
                                                    {setValue(state.tyreAxles[0]?.nsTyrePressure, 'psi')}
                                                </Typography>
                                            </Grid>
                                            <Grid item xs={6}>
                                                <InputLabel style={style.axNsout}>Tyre</InputLabel>
                                                <Typography style={style.typography} variant="subtitle1">
                                                    {setValue(state.tyreAxles[0]?.nsTyreMaker, '')}
                                                </Typography>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    )}
                    {/* Axel 2 ..................... */}
                    {show.showAxle2 &&
                        (isFourAxles ? (
                            <Grid item xs={12} sm={12} md={6} lg={6} xl={3}>
                                <Grid item xs={12} sm={12}>
                                    <Grid container xs={12} direction="row" justify="space-evenly">
                                        <Grid item xs={2} />
                                        <Grid item xs={3}>
                                            <h3 className={classes.axelTitles}>AXLE 2</h3>
                                        </Grid>
                                        <Grid item xs={5} />
                                    </Grid>
                                </Grid>
                                <Grid item xs={12} sm={12}>
                                    <Grid container xs={12} direction="row" justify="space-evenly">
                                        <Grid item xs={2}>
                                            <Grid container spacing={2}>
                                                <Grid item xs={12}>
                                                    <InputLabel style={style.axOsout}>Depth</InputLabel>
                                                    <Typography style={style.typography} variant="subtitle1">
                                                        {setValue(state.tyreAxles[1]?.osTreadDepth, 'mm')}
                                                    </Typography>
                                                </Grid>
                                            </Grid>
                                            <Grid container spacing={2}>
                                                <Grid item xs={12}>
                                                    <InputLabel style={style.axNsout}>Depth</InputLabel>
                                                    <Typography style={style.typography} variant="subtitle1">
                                                        {setValue(state.tyreAxles[1]?.nsTreadDepth, 'mm')}
                                                    </Typography>
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                        <Grid item xs={3}>
                                            <InputLabel style={style.axBreak}>Brake Lining (%)</InputLabel>
                                            <Typography style={style.brakeTypography} variant="subtitle1">
                                                {setValue(state.tyreAxles[1]?.osBrakeLineRemaining, '%')}
                                            </Typography>
                                            <img src={singleAxel} height="250px" width="100%" style={style.axImage} />
                                            <InputLabel style={style.axBreak}>Brake Lining (%)</InputLabel>
                                            <Typography style={style.brakeTypography} variant="subtitle1">
                                                {setValue(state.tyreAxles[1]?.nsBrakeLineRemaining, '%')}
                                            </Typography>
                                        </Grid>
                                        <Grid item xs={5}>
                                            <Grid container spacing={2}>
                                                <Grid item xs={6}>
                                                    {' '}
                                                    <InputLabel style={style.axOsout}>Pressure</InputLabel>
                                                    <Typography style={style.typography} variant="subtitle1">
                                                        {setValue(state.tyreAxles[1]?.osTyrePressure, 'psi')}
                                                    </Typography>
                                                </Grid>
                                                <Grid item xs={6}>
                                                    <InputLabel style={style.axOsout}>Tyre</InputLabel>
                                                    <Typography style={style.typography} variant="subtitle1">
                                                        {setValue(state.tyreAxles[1]?.osTyreMaker, '')}
                                                    </Typography>
                                                </Grid>
                                            </Grid>
                                            <Grid container spacing={2}>
                                                <Grid item xs={6}>
                                                    {' '}
                                                    <InputLabel style={style.axNsout}>Pressure</InputLabel>
                                                    <Typography style={style.typography} variant="subtitle1">
                                                        {setValue(state.tyreAxles[1]?.nsTyrePressure, 'psi')}
                                                    </Typography>
                                                </Grid>
                                                <Grid item xs={6}>
                                                    <InputLabel style={style.axNsout}>Tyre</InputLabel>
                                                    <Typography style={style.typography} variant="subtitle1">
                                                        {setValue(state.tyreAxles[1]?.nsTyreMaker, '')}
                                                    </Typography>
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                        ) : (
                            <Grid item xs={12} sm={12} md={6} lg={6} xl={3}>
                                <Grid item xs={12} sm={12}>
                                    <Grid container xs={12} direction="row" justify="space-evenly">
                                        <Grid item xs={2} />
                                        <Grid item xs={3}>
                                            <h3 className={classes.axelTitles}>AXLE 2</h3>
                                        </Grid>
                                        <Grid item xs={5} />
                                    </Grid>
                                </Grid>
                                <Grid item xs={12} sm={12}>
                                    <Grid container xs={12} direction="row" justify="space-evenly">
                                        <Grid item xs={2}>
                                            <Grid container spacing={2}>
                                                <Grid item xs={12}>
                                                    <InputLabel style={style.Ax2osOut}>Depth</InputLabel>
                                                    <Typography style={style.typography} variant="subtitle1">
                                                        {setValue(state.tyreAxles[1]?.osTreadDepth, 'mm')}
                                                    </Typography>
                                                </Grid>
                                            </Grid>
                                            <Grid container spacing={2}>
                                                <Grid item xs={12}>
                                                    <InputLabel style={style.Ax2osin}>Depth</InputLabel>
                                                    <Typography style={style.typography} variant="subtitle1">
                                                        {setValue(state.tyreAxles[1]?.osFrontTreadDepth, 'mm')}
                                                    </Typography>
                                                </Grid>
                                            </Grid>
                                            <Grid container spacing={2}>
                                                <Grid item xs={12}>
                                                    <InputLabel style={style.Ax2nsin}>Depth</InputLabel>
                                                    <Typography style={style.typography} variant="subtitle1">
                                                        {setValue(state.tyreAxles[1]?.nsFrontTreadDepth, 'mm')}
                                                    </Typography>
                                                </Grid>
                                            </Grid>
                                            <Grid container spacing={2}>
                                                <Grid item xs={12}>
                                                    <InputLabel style={style.Ax2osin}>Depth</InputLabel>
                                                    <Typography style={style.typography} variant="subtitle1">
                                                        {setValue(state.tyreAxles[1]?.nsTreadDepth, 'mm')}
                                                    </Typography>
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                        <Grid item xs={3}>
                                            <img src={doubleAxelOne} height="100px" width="100%" />
                                            <InputLabel style={style.axBreak}>Brake Lining (%)</InputLabel>
                                            <Typography style={style.brakeTypography} variant="subtitle1">
                                                {setValue(state.tyreAxles[1]?.osBrakeLineRemaining, '%')}
                                            </Typography>

                                            <img src={doubleAxelTwo} height="50px" width="100%" />
                                            <InputLabel style={style.axBreak}>Brake Lining (%)</InputLabel>
                                            <Typography style={style.brakeTypography} variant="subtitle1">
                                                {setValue(state.tyreAxles[1]?.nsBrakeLineRemaining, '%')}
                                            </Typography>

                                            <img src={doubleAxelThree} height="100px" width="100%" />
                                        </Grid>
                                        <Grid item xs={5}>
                                            <Grid container spacing={2}>
                                                <Grid item xs={6}>
                                                    <InputLabel style={style.Ax2osOut}>Pressure</InputLabel>
                                                    <Typography style={style.typography} variant="subtitle1">
                                                        {setValue(state.tyreAxles[1]?.osTyrePressure, 'psi')}
                                                    </Typography>
                                                </Grid>
                                                <Grid item xs={6}>
                                                    <InputLabel style={style.Ax2osOut}>Tyre</InputLabel>
                                                    <Typography style={style.typography} variant="subtitle1">
                                                        {setValue(state.tyreAxles[1]?.osTyreMaker, '')}
                                                    </Typography>
                                                </Grid>
                                            </Grid>
                                            <Grid container spacing={2}>
                                                <Grid item xs={6}>
                                                    {' '}
                                                    <InputLabel style={style.Ax2osin}>Pressure</InputLabel>
                                                    <Typography style={style.typography} variant="subtitle1">
                                                        {setValue(state.tyreAxles[1]?.osFrontTyrePressure, 'psi')}
                                                    </Typography>
                                                </Grid>
                                                <Grid item xs={6}>
                                                    {' '}
                                                    <InputLabel style={style.Ax2osin}>Tyre</InputLabel>
                                                    <Typography style={style.typography} variant="subtitle1">
                                                        {setValue(state.tyreAxles[1]?.osFrontTyreMaker, '')}
                                                    </Typography>
                                                </Grid>
                                            </Grid>
                                            <Grid container spacing={2}>
                                                <Grid item xs={6}>
                                                    {' '}
                                                    <InputLabel style={style.Ax2nsin}>Pressure</InputLabel>
                                                    <Typography style={style.typography} variant="subtitle1">
                                                        {setValue(state.tyreAxles[1]?.nsFrontTyrePressure, 'psi')}
                                                    </Typography>
                                                </Grid>
                                                <Grid item xs={6}>
                                                    {' '}
                                                    <InputLabel style={style.Ax2nsin}>Tyre</InputLabel>
                                                    <Typography style={style.typography} variant="subtitle1">
                                                        {setValue(state.tyreAxles[1]?.nsFrontTyreMaker, '')}
                                                    </Typography>
                                                </Grid>
                                            </Grid>
                                            <Grid container spacing={2}>
                                                <Grid item xs={6}>
                                                    {' '}
                                                    <InputLabel style={style.Ax2osin}>Pressure</InputLabel>
                                                    <Typography style={style.typography} variant="subtitle1">
                                                        {setValue(state.tyreAxles[1]?.nsTyrePressure, 'psi')}
                                                    </Typography>
                                                </Grid>
                                                <Grid item xs={6}>
                                                    <InputLabel style={style.Ax2osin}>Tyre</InputLabel>
                                                    <Typography style={style.typography} variant="subtitle1">
                                                        {setValue(state.tyreAxles[1]?.nsTyreMaker, '')}
                                                    </Typography>
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                        ))}

                    {/* Axel 3 ..................... */}
                    {show.showAxle3 && (
                        <Grid item xs={12} sm={12} md={6} lg={6} xl={3}>
                            <Grid item xs={12} sm={12}>
                                <Grid container xs={12} direction="row" justify="space-evenly">
                                    <Grid item xs={2} />
                                    <Grid item xs={3}>
                                        <h3 className={classes.axelTitles}>AXLE 3</h3>
                                    </Grid>
                                    <Grid item xs={5} />
                                </Grid>
                            </Grid>
                            <Grid item xs={12} sm={12}>
                                <Grid container xs={12} direction="row" justify="space-evenly">
                                    <Grid item xs={2}>
                                        <Grid container spacing={2}>
                                            <Grid item xs={12}>
                                                <InputLabel style={style.Ax2osOut}>Depth</InputLabel>
                                                <Typography style={style.typography} variant="subtitle1">
                                                    {setValue(state.tyreAxles[2]?.osTreadDepth, 'mm')}
                                                </Typography>
                                            </Grid>
                                        </Grid>
                                        <Grid container spacing={2}>
                                            <Grid item xs={12}>
                                                <InputLabel style={style.Ax2osin}>Depth</InputLabel>
                                                <Typography style={style.typography} variant="subtitle1">
                                                    {setValue(state.tyreAxles[2]?.osFrontTreadDepth, 'mm')}
                                                </Typography>
                                            </Grid>
                                        </Grid>
                                        <Grid container spacing={2}>
                                            <Grid item xs={12}>
                                                <InputLabel style={style.Ax2nsin}>Depth</InputLabel>
                                                <Typography style={style.typography} variant="subtitle1">
                                                    {setValue(state.tyreAxles[2]?.nsFrontTreadDepth, 'mm')}
                                                </Typography>
                                            </Grid>
                                        </Grid>
                                        <Grid container spacing={2}>
                                            <Grid item xs={12}>
                                                <InputLabel style={style.Ax2osin}>Depth</InputLabel>
                                                <Typography style={style.typography} variant="subtitle1">
                                                    {setValue(state.tyreAxles[2]?.nsTreadDepth, 'mm')}
                                                </Typography>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                    <Grid item xs={3}>
                                        <img src={doubleAxelOne} height="100px" width="100%" />
                                        <InputLabel style={style.axBreak}>Brake Lining (%)</InputLabel>
                                        <Typography style={style.brakeTypography} variant="subtitle1">
                                            {setValue(state.tyreAxles[2]?.osBrakeLineRemaining, '%')}
                                        </Typography>

                                        <img src={doubleAxelTwo} height="50px" width="100%" />
                                        <InputLabel style={style.axBreak}>Brake Lining (%)</InputLabel>
                                        <Typography style={style.brakeTypography} variant="subtitle1">
                                            {setValue(state.tyreAxles[2]?.nsBrakeLineRemaining, '%')}
                                        </Typography>

                                        <img src={doubleAxelThree} height="100px" width="100%" />
                                    </Grid>
                                    <Grid item xs={5}>
                                        <Grid container spacing={2}>
                                            <Grid item xs={6}>
                                                <InputLabel style={style.Ax2osOut}>Pressure</InputLabel>
                                                <Typography style={style.typography} variant="subtitle1">
                                                    {setValue(state.tyreAxles[2]?.osTyrePressure, 'psi')}
                                                </Typography>
                                            </Grid>
                                            <Grid item xs={6}>
                                                <InputLabel style={style.Ax2osOut}>Tyre</InputLabel>
                                                <Typography style={style.typography} variant="subtitle1">
                                                    {setValue(state.tyreAxles[2]?.osTyreMaker, '')}
                                                </Typography>
                                            </Grid>
                                        </Grid>
                                        <Grid container spacing={2}>
                                            <Grid item xs={6}>
                                                {' '}
                                                <InputLabel style={style.Ax2osin}>Pressure</InputLabel>
                                                <Typography style={style.typography} variant="subtitle1">
                                                    {setValue(state.tyreAxles[2]?.osFrontTyrePressure, 'psi')}
                                                </Typography>
                                            </Grid>
                                            <Grid item xs={6}>
                                                {' '}
                                                <InputLabel style={style.Ax2osin}>Tyre</InputLabel>
                                                <Typography style={style.typography} variant="subtitle1">
                                                    {setValue(state.tyreAxles[2]?.osFrontTyreMaker, '')}
                                                </Typography>
                                            </Grid>
                                        </Grid>
                                        <Grid container spacing={2}>
                                            <Grid item xs={6}>
                                                {' '}
                                                <InputLabel style={style.Ax2nsin}>Pressure</InputLabel>
                                                <Typography style={style.typography} variant="subtitle1">
                                                    {setValue(state.tyreAxles[2]?.nsFrontTyrePressure, 'psi')}
                                                </Typography>
                                            </Grid>
                                            <Grid item xs={6}>
                                                {' '}
                                                <InputLabel style={style.Ax2nsin}>Tyre</InputLabel>
                                                <Typography style={style.typography} variant="subtitle1">
                                                    {setValue(state.tyreAxles[2]?.nsFrontTyreMaker, '')}
                                                </Typography>
                                            </Grid>
                                        </Grid>
                                        <Grid container spacing={2}>
                                            <Grid item xs={6}>
                                                {' '}
                                                <InputLabel style={style.Ax2osin}>Pressure</InputLabel>
                                                <Typography style={style.typography} variant="subtitle1">
                                                    {setValue(state.tyreAxles[2]?.nsTyrePressure, 'psi')}
                                                </Typography>
                                            </Grid>
                                            <Grid item xs={6}>
                                                <InputLabel style={style.Ax2osin}>Tyre</InputLabel>
                                                <Typography style={style.typography} variant="subtitle1">
                                                    {setValue(state.tyreAxles[2]?.nsTyreMaker, '')}
                                                </Typography>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    )}
                    {/* Axel 4 ..................... */}
                    {show.showAxle4 && (
                        <Grid item xs={12} sm={12} md={6} lg={6} xl={3}>
                            <Grid item xs={12} sm={12}>
                                <Grid container xs={12} direction="row" justify="space-evenly">
                                    <Grid item xs={2} />
                                    <Grid item xs={3}>
                                        <h3 className={classes.axelTitles}>AXLE 4</h3>
                                    </Grid>
                                    <Grid item xs={5} />
                                </Grid>
                            </Grid>
                            <Grid item xs={12} sm={12}>
                                <Grid container xs={12} direction="row" justify="space-evenly">
                                    <Grid item xs={2}>
                                        <Grid container spacing={2}>
                                            <Grid item xs={12}>
                                                <InputLabel style={style.Ax2osOut}>Depth</InputLabel>
                                                <Typography style={style.typography} variant="subtitle1">
                                                    {setValue(state.tyreAxles[3]?.osTreadDepth, 'mm')}
                                                </Typography>
                                            </Grid>
                                        </Grid>
                                        <Grid container spacing={2}>
                                            <Grid item xs={12}>
                                                <InputLabel style={style.Ax2osin}>Depth</InputLabel>
                                                <Typography style={style.typography} variant="subtitle1">
                                                    {setValue(state.tyreAxles[3]?.osFrontTreadDepth, 'mm')}
                                                </Typography>
                                            </Grid>
                                        </Grid>
                                        <Grid container spacing={2}>
                                            <Grid item xs={12}>
                                                <InputLabel style={style.Ax2nsin}>Depth</InputLabel>
                                                <Typography style={style.typography} variant="subtitle1">
                                                    {setValue(state.tyreAxles[3]?.nsFrontTreadDepth, 'mm')}
                                                </Typography>
                                            </Grid>
                                        </Grid>
                                        <Grid container spacing={2}>
                                            <Grid item xs={12}>
                                                <InputLabel style={style.Ax2osin}>Depth</InputLabel>
                                                <Typography style={style.typography} variant="subtitle1">
                                                    {setValue(state.tyreAxles[3]?.nsTreadDepth, 'mm')}
                                                </Typography>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                    <Grid item xs={3}>
                                        <img src={doubleAxelOne} height="100px" width="100%" />
                                        <InputLabel style={style.axBreak}>Brake Lining (%)</InputLabel>
                                        <Typography style={style.brakeTypography} variant="subtitle1">
                                            {setValue(state.tyreAxles[3]?.osBrakeLineRemaining, '%')}
                                        </Typography>

                                        <img src={doubleAxelTwo} height="50px" width="100%" />
                                        <InputLabel style={style.axBreak}>Brake Lining (%)</InputLabel>
                                        <Typography style={style.brakeTypography} variant="subtitle1">
                                            {setValue(state.tyreAxles[3]?.nsBrakeLineRemaining, '%')}
                                        </Typography>

                                        <img src={doubleAxelThree} height="100px" width="100%" />
                                    </Grid>
                                    <Grid item xs={5}>
                                        <Grid container spacing={2}>
                                            <Grid item xs={6}>
                                                <InputLabel style={style.Ax2osOut}>Pressure</InputLabel>
                                                <Typography style={style.typography} variant="subtitle1">
                                                    {setValue(state.tyreAxles[3]?.osTyrePressure, 'psi')}
                                                </Typography>
                                            </Grid>
                                            <Grid item xs={6}>
                                                <InputLabel style={style.Ax2osOut}>Tyre</InputLabel>
                                                <Typography style={style.typography} variant="subtitle1">
                                                    {setValue(state.tyreAxles[3]?.osTyreMaker, '')}
                                                </Typography>
                                            </Grid>
                                        </Grid>
                                        <Grid container spacing={2}>
                                            <Grid item xs={6}>
                                                {' '}
                                                <InputLabel style={style.Ax2osin}>Pressure</InputLabel>
                                                <Typography style={style.typography} variant="subtitle1">
                                                    {setValue(state.tyreAxles[3]?.osFrontTyrePressure, 'psi')}
                                                </Typography>
                                            </Grid>
                                            <Grid item xs={6}>
                                                {' '}
                                                <InputLabel style={style.Ax2osin}>Tyre</InputLabel>
                                                <Typography style={style.typography} variant="subtitle1">
                                                    {setValue(state.tyreAxles[3]?.osFrontTyreMaker, '')}
                                                </Typography>
                                            </Grid>
                                        </Grid>
                                        <Grid container spacing={2}>
                                            <Grid item xs={6}>
                                                {' '}
                                                <InputLabel style={style.Ax2nsin}>Pressure</InputLabel>
                                                <Typography style={style.typography} variant="subtitle1">
                                                    {setValue(state.tyreAxles[3]?.nsFrontTyrePressure, 'psi')}
                                                </Typography>
                                            </Grid>
                                            <Grid item xs={6}>
                                                {' '}
                                                <InputLabel style={style.Ax2nsin}>Tyre</InputLabel>
                                                <Typography style={style.typography} variant="subtitle1">
                                                    {setValue(state.tyreAxles[3]?.nsFrontTyreMaker, '')}
                                                </Typography>
                                            </Grid>
                                        </Grid>
                                        <Grid container spacing={2}>
                                            <Grid item xs={6}>
                                                {' '}
                                                <InputLabel style={style.Ax2osin}>Pressure</InputLabel>
                                                <Typography style={style.typography} variant="subtitle1">
                                                    {setValue(state.tyreAxles[3]?.nsTyrePressure, 'psi')}
                                                </Typography>
                                            </Grid>
                                            <Grid item xs={6}>
                                                <InputLabel style={style.Ax2osin}>Tyre</InputLabel>
                                                <Typography style={style.typography} variant="subtitle1">
                                                    {setValue(state.tyreAxles[3]?.nsTyreMaker, '')}
                                                </Typography>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    )}
                </Grid>
            </Paper>
        </Grid>
    );
});
export default EditAxel;
